import { observer } from 'mobx-react-lite';
import _ from 'lodash';
import { components } from 'react-select';
import Async from 'react-select/async';
import { CompanyAccountApi } from '../../../swagger_client/src';
import { taglistStyle } from '../../../Utils/reactSelectStyles';
import { useTranslation } from 'react-i18next';
import { Controller } from 'react-hook-form';
import PropTypes from 'prop-types';
import { createInputValueRegexContent } from '../../../Utils/filter/createFilterInputValue';

SelectCompanyAccount.propTypes = {
  defaultValue: PropTypes.array,
  control: PropTypes.object.isRequired,
  name: PropTypes.string,
};

function SelectCompanyAccount({
  defaultValue,
  control,
  name,
}) {
  const
    companyAccountApi = new CompanyAccountApi(),
    { t } = useTranslation();

  async function promiseOptions(inputValue) {
    const items = await companyAccountApi.companyAccountFind({
      filter: JSON.stringify({
        where: { name: { regexp: `/${createInputValueRegexContent(inputValue)}/i` } },
        limit: 50,
        order: 'name asc',
      }),
    });
    const newOptions = _.map(items, (o) => {
      return {
        label: o.name,
        value: o,
      };
    });
    return newOptions.sort((a, b) => a.label.localeCompare(b.label));
  }

  return (
    <Controller
      render={({ field }) => (
        <Async
          {...field}
          components={{ Input: (props) => <components.Input {...props} data-testid={name} /> }}
          cacheOptions
          defaultValue={defaultValue}
          styles={taglistStyle}
          menuPosition="fixed"
          defaultOptions
          isClearable
          isMulti
          inputId="companyAccounts"
          placeholder={t('select company accounts')}
          onChange={(selected) => field.onChange(selected.map(select => select.value))}
          loadOptions={promiseOptions}
          name={name}
        />
      )}
      control={control}
      name={name}
      defaultValue={defaultValue}
    />
  );
}

export default observer(SelectCompanyAccount);
